import { Component, OnInit, EventEmitter, Output, ViewEncapsulation, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ClassificationService } from '../../shared/services/classification.service';
import {
  IGroupClassification, IClassification
} from '../../shared/models/classification';
import { Router } from '@angular/router';
import { RelationshipService } from 'src/app/shared/services/relationship.service';
import { IColumnHeader, IRelationshipView } from 'src/app/shared/models/relationship';
import { Config } from '../../shared/config';
import { CommonService } from 'src/app/shared/services/common.service';
import { IWFObjectType, IObjectStatus, IToolBarClick, IFiscalYear, ISearch } from 'src/app/shared/models/common';
import { FrameworkService } from 'gadoe-framework';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
@Component({
  selector: 'app-search',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  providers: [ClassificationService]
})


export class SearchComponent implements OnInit {
  public fiscalyears: IFiscalYear[] = [];
   tfiscalyears: IFiscalYear[] = [];
  _showClassification: boolean;
  _showRelationship: boolean;
  Objectstatus: IObjectStatus[];
  groups: IGroupClassification[] = [];
  tgroups: IGroupClassification[] = [];
  columnheaders: IColumnHeader[] = [];
  tcolumnheaders: IColumnHeader[] = [];
  // group: IGroupClassification = { groupHeaderID: 0, name: '' };
  columnheader: IColumnHeader = { columnHeaderID: 0, name: '' };
  defaultcolumnheader: IColumnHeader = { columnHeaderID: -1, name: 'Select' };
  defaultGroup: IGroupClassification = { groupHeaderID: -1, name: 'Select' };
  toolbarclick: IToolBarClick;
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'startsWith'
  };
  @Input() set showClassification(value: boolean) {
    this._showClassification = value;
  }
  get showClassification(): boolean {
    return this._showClassification;
  }

  @Input() set showRelationship(value: boolean) {
    this._showRelationship = value;
  }
  get showRelationship(): boolean {
    return this._showRelationship;
  }

  @Output() searchValues: EventEmitter<any> = new EventEmitter();
  //@Output() selectedItem: EventEmitter<IClassification> = new EventEmitter<IClassification>();



  // model: IClassification;
  // relationshipModel: IRelationshipView;
  searchModel: ISearch;
  // public searchForm: FormGroup = new FormGroup({
  //   'columnHeaderrelationship': new FormControl('')
  // });
  // classificationLineItemList: FormGroup;

  constructor(private frmbuilder: FormBuilder,
    private dataService: ClassificationService,
    private relationshipService: RelationshipService, private commonService: CommonService,
    private frameworkService: FrameworkService,
    private route: Router) {
  }

  ngOnInit() {
    // this.view = false;
    this.modelInit();
    //this.relationshipModelInit();
    //this.searchFormInit();
    this.getFiscalYears();
    this.getGroupClassification();
    this.getColumnHeaders();
    this.getstatus();
    this.statustoolbarclick();
  }
  modelInit() {
    this.searchModel = {
      fiscalYear: -1,
      fiscalYearConfigID: -1,
      columnHeaderID: -1,
      groupclassificationID: 0,
      groupclassificationName: '',
      groupHeaderID: 0,
      name: ''
    };
  }

  // relationshipModelInit() {
  //   this.relationshipModel = {
  //     fiscalYearConfigID: -1,
  //     columnHeaderID: -1,
  //     groupHeaderID: 0, //10,
  //     lineItemID: 0, //1726,
  //     sectionHeaderID: 0, //33,
  //     name: '',
  //     fiscalYear: '',
  //     codetype: ''
  //   };
  // }
  refreshtoolbar() {
    // this.onClickExpand('Collapse All');
    this.frameworkService.refreshToolBarItems(
      {
        controlID: Config.selectedTabMenuItem.controlID
        , roleID: Config.selectedTabMenuItem.itApplicationRoleID
        , statusID: Config.StatusID
      });
  }
  getstatus() {
    this.commonService.GetObjectStatus(Config.fiscalYearConfigID, IWFObjectType.COA)
      .subscribe((response: IObjectStatus[]) => {
        this.Objectstatus = response;
        if (response.length !== 0) {
          Config.StatusID = 0;
          Config.StatusID = this.Objectstatus[0].statusID;
        }
        this.frameworkService.hideSpinner();
        this.refreshtoolbar();
      },
        (err: any) => {
          this.frameworkService.logError(err),

            this.frameworkService.hideSpinner();
        },
        () => this.frameworkService.logInfo('getstatus() retrieved systems'));
  }
  getFiscalYears() {
    this.dataService.getFiscalYears()
      .subscribe((response: IFiscalYear[]) => {
        this.fiscalyears = response;
        if (response.length !== 0) {
          if (Config.fiscalYearConfigID === undefined) {
            Config.fiscalYearConfigID = this.fiscalyears[0].fiscalYearConfigID;
            Config.fiscalYear = +this.fiscalyears[0].fiscalYear;

          }
            this.searchModel.fiscalYearConfigID = Config.fiscalYearConfigID;
            this.searchModel.fiscalYear = Config.fiscalYear;
        }
        this.tfiscalyears = this.fiscalyears;
        this.getstatus();
        // this.fiscalyears.unshift(this.defaultFiscalYear);
      },
        (err: any) => this.frameworkService.logError(err),
        () => this.frameworkService.logInfo('getFiscalYears() retrieved fiscalyears'));
  }

  statustoolbarclick() {
    this.commonService.toolBarclick.subscribe(value => {
      this.toolbarclick = value;
      if (this.toolbarclick.isClicked === true && this.toolbarclick.toolbarItemId === 20) {
        this.getFiscalYears();
        // if (Config.selectedTab === 2) {
        // this.searchValues.emit(this.searchModel);
        // } else if (Config.selectedTab === 1) {
        this.searchValues.emit(this.searchModel);
        // }
      }
    });
    this.toolbarclick.isClicked = false;
  }
  getGroupClassification() {

    this.dataService.getGroupClassifications()
      .subscribe((response: IGroupClassification[]) => {
        this.groups = response;
        if (this.groups != null && this.groups.length > 0) {
          // this.view = true;
          this.groups.unshift(this.defaultGroup);
          this.searchModel.groupclassificationID = -1;
        }
        this.tgroups = this.groups;
      },
        (err: any) => this.frameworkService.logError(err),
        () => this.frameworkService.logInfo('getGroupClassification() retrieved groups'));
  }
  handleGroupHeaderFilter(value) {
    this.tgroups = this.groups.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  handleColumnHeaderFilter(value) {
    this.tcolumnheaders = this.columnheaders.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  handleFiscalYearFilter(value) {
    this.tfiscalyears = this.fiscalyears.filter((s) => s.fiscalYear.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  getColumnHeaders() {
    this.relationshipService.GetRelationshipColumns()
      .subscribe((response: IColumnHeader[]) => {
        this.columnheaders = response;
        this.tcolumnheaders = this.columnheaders;
        if (this.tcolumnheaders.length > 1) {
          // this.columnheaders.unshift(this.columnheader);
          this.tcolumnheaders.unshift(this.defaultcolumnheader);
          this.searchModel.columnHeaderID = -1;
          //  this.relationshipModel.name = 'Select';
        }
      },
        (err: any) => this.frameworkService.logError(err),
        () => this.frameworkService.logInfo('GetRelationshipColumns() retrieved Relationship Columns'));
  }
  fiscalyearOnChange(event) {
    this.searchModel.fiscalYearConfigID = Config.fiscalYearConfigID = event;
    //this.model.groupclassificationID = -1;
    this.getstatus();
    const index = this.fiscalyears.findIndex(role => role.fiscalYearConfigID === event);
    if (index > -1) {
      this.searchModel.fiscalYear = Config.fiscalYear = +this.tfiscalyears[index].fiscalYear;
      this.searchModel.fiscalYearConfigID = Config.fiscalYearConfigID = event;
    }
    //if (Config.selectedTab === 2) {
    //   this.searchValues.emit(this.searchModel);
    // } else if (Config.selectedTab === 1) {
    this.searchValues.emit(this.searchModel);
    //  }

  }
  groupclassificationOnChange(event) {
    if (event === -1) {
      this.searchModel.groupclassificationID = event;
    } else {
      this.searchModel.groupclassificationID = event;
      Config.fiscalYearConfigID = this.searchModel.fiscalYearConfigID;
      // this.searchModel.groupclassificationName = this.tgroups[event].name;

      this.searchModel.groupclassificationName =
       this.tgroups.filter((s) => s.groupHeaderID.toString().indexOf(event.toString()) !== -1)[0].name;
    }
    this.searchValues.emit(this.searchModel);
  }
  columnHeaderOnChange(event) {
    if (event.columnHeaderID === -1) {
      this.searchModel.columnHeaderID = event;
    } else {
      this.searchModel.fiscalYearConfigID = Config.fiscalYearConfigID = this.searchModel.fiscalYearConfigID;
      for (let a = this.tcolumnheaders.length - 1; a >= 0; a--) {
        if (this.tcolumnheaders[a].columnHeaderID === event) {
          this.searchModel.columnHeaderID = event;
          this.searchModel.name = this.tcolumnheaders[a].name;
        }
      }
    }
    this.searchValues.emit(this.searchModel);
  }
}

